import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const ScoreBadge = ({ score, size = 'md', showLabel = true, max = 10 }) => {
  // Show "S/D" (Sin Datos) when score is null, undefined, or 0
  if (!score || score === 0) {
    return (
      <div className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-gray-100 text-gray-500 border border-gray-200">
        <span className="text-xs font-medium">S/D</span>
      </div>
    );
  }

  // Normalize score to 0-10 scale for color calculation
  const normalizedScore = max === 100 ? score / 10 : score;

  const getColor = (normalizedScore) => {
    if (normalizedScore >= 8) return { bg: 'bg-green-100', text: 'text-green-700', border: 'border-green-300', icon: TrendingUp };
    if (normalizedScore >= 6) return { bg: 'bg-brand-100', text: 'text-brand-700', border: 'border-brand-300', icon: TrendingUp };
    if (normalizedScore >= 4) return { bg: 'bg-yellow-100', text: 'text-yellow-700', border: 'border-yellow-300', icon: null };
    return { bg: 'bg-red-100', text: 'text-red-700', border: 'border-red-300', icon: TrendingDown };
  };

  const color = getColor(normalizedScore);
  const Icon = color.icon;

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5'
  };

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  return (
    <div className={`inline-flex items-center gap-1.5 rounded-full border ${color.bg} ${color.text} ${color.border} ${sizeClasses[size]} font-semibold`}>
      {Icon && <Icon className={iconSizes[size]} />}
      <span>{score.toFixed(1)}</span>
      {showLabel && <span className="font-normal opacity-75">/{max}</span>}
    </div>
  );
};

export default ScoreBadge;
